import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeDemo = () => {
  const { theme, toggleTheme, isLight, isDark } = useTheme();

  return (
    <div className="page-content">
      <div className="page-header">
        <h1 className="gradient-text-animated">🎨 Theme Demo</h1>
        <p>Experience the enhanced Solana-themed animations and smooth transitions</p>
      </div>
      
      <div className="dashboard-cards-grid">
        {/* Theme Toggle Card */}
        <div className="content-card animated-card">
          <h3>Theme Controls</h3>
          <p>Current theme: <strong>{theme}</strong></p>
          <button 
            onClick={toggleTheme}
            className="futuristic-glow animated-button"
            style={{ marginTop: '16px' }}
          >
            Switch to {isLight ? 'Dark' : 'Light'} Mode
          </button>
        </div>

        {/* Animation Showcase */}
        <div className="content-card animated-card">
          <h3>Animation Effects</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
            <button className="animated-button hover-lift" style={{ padding: '8px 16px' }}>
              Hover Lift Effect
            </button>
            <button className="animated-button hover-scale" style={{ padding: '8px 16px' }}>
              Hover Scale Effect
            </button>
            <button className="animated-button hover-rotate" style={{ padding: '8px 16px' }}>
              Hover Rotate Effect
            </button>
          </div>
        </div>

        {/* Loading Animation */}
        <div className="content-card animated-card">
          <h3>Loading States</h3>
          <div style={{ marginTop: '16px' }}>
            <div className="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <p style={{ marginTop: '8px', fontSize: '0.875rem' }}>Loading animation</p>
          </div>
        </div>

        {/* Pulse Effect */}
        <div className="content-card animated-card">
          <h3>Pulse Effects</h3>
          <div style={{ marginTop: '16px' }}>
            <div 
              className="pulse-glow"
              style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                background: 'var(--solana-gradient)',
                margin: '0 auto'
              }}
            ></div>
            <p style={{ marginTop: '8px', fontSize: '0.875rem', textAlign: 'center' }}>Pulsing glow</p>
          </div>
        </div>

        {/* Shimmer Effect */}
        <div className="content-card animated-card">
          <h3>Shimmer Effects</h3>
          <div style={{ marginTop: '16px' }}>
            <div 
              className="shimmer"
              style={{
                width: '100%',
                height: '40px',
                background: 'var(--surface-secondary)',
                borderRadius: '8px'
              }}
            ></div>
            <p style={{ marginTop: '8px', fontSize: '0.875rem' }}>Shimmer loading effect</p>
          </div>
        </div>

        {/* Gradient Text */}
        <div className="content-card animated-card">
          <h3>Gradient Text</h3>
          <div style={{ marginTop: '16px' }}>
            <h4 className="gradient-text">Solana Purple to Green</h4>
            <p style={{ fontSize: '0.875rem' }}>Animated gradient text effect</p>
          </div>
        </div>

        {/* Animated Border */}
        <div className="content-card animated-card">
          <h3>Animated Border</h3>
          <div style={{ marginTop: '16px' }}>
            <div 
              className="animated-border"
              style={{
                width: '100%',
                height: '60px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              Rotating Border
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeDemo; 